import { useMatches } from '@remix-run/react'
import { computeUspVisibility, type UspMatch } from '~/utils'

const useUspBlock = (): boolean => {
  const matches = useMatches() as UspMatch[]
  return computeUspVisibility(matches)
}

export default useUspBlock
